import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import style from './checkbox.less';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import FormPureComponent from './../generic.component.jsx';
import FormComponentItem from '../FormComponentItem.jsx';
import classNames from 'classnames';
import { setFieldValue } from '../../app.reducer.jsx';
import { bindActionCreators } from '../../app.store.jsx';
import { KEY_CODES, compareObjectsInclusive } from '../../../common/utils.jsx';

const { ENTER, SPACE, ARROW_DOWN, ARROW_UP, ARROW_RIGHT, ARROW_LEFT } = KEY_CODES;
const TYPES = PropTypes;
export class Checkbox extends FormComponentItem {
    constructor() {
        super();
        this.keyDownHandler = this.keyDownHandler.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'value', 'checked', 'disabled', 'id', 'num', 'title', 'name' ]);
    }
    keyDownHandler(event) {
        const keyCode = event.keyCode;
        const node = ReactDOM.findDOMNode(this);
        if (ARROW_DOWN === keyCode || ARROW_RIGHT === keyCode) {
            if (node.nextSibling) {
                node.nextSibling.focus();
                event.preventDefault();
            }
        } else if (ARROW_UP === keyCode || ARROW_LEFT === keyCode) {
            if (node.previousSibling) {
                node.previousSibling.focus();
                event.preventDefault();
            }
        } else if (ENTER === keyCode || SPACE === keyCode) {
            this.onChangeHandler();
            event.preventDefault();
        }
    }
    render() {
        const { title, value, name, id, num, checked, cssClass, root, disabled } = this.props;
        const btnId = root ? `${root}-${id}-${num}` : `${id}-${num}`;
        const btnClass = classNames(style.checkbox, { [style.active]: checked }, cssClass, { [style.disabled]: disabled });
        const iconClassName = classNames(style.checkboxIcon, { [style.checked]: checked });
        const tabIndex = disabled ? -1 : 0;
        return (
            <label htmlFor={btnId} className={btnClass} tabIndex={tabIndex} onKeyDown={this.keyDownHandler}>
                <input type="checkbox" name={name} id={btnId} onChange={this.onChangeHandler} value={value} checked={checked} className={style.hidden}/>
                <span className={style.checkboxText}>{title}</span>
                <span className={iconClassName}></span>
            </label>
        );
    }
}
Checkbox.defaultProps = { checked: false };

const UNKNOWN = 'UNKNOWN';
export default class CheckboxButtons extends FormPureComponent {
    constructor() {
        super();
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this._setFieldValue = bindActionCreators(setFieldValue);
        this.buildOptionsList = this.buildOptionsList.bind(this);
        this.buildOption = this.buildOption.bind(this);
    }

    buildOption(item, index) {
        const { value, disabled, root, id } = this.props;
        const { value: itemValue, title } = item;
        let checked,
            buttonId = `${id}-${itemValue}`;
        if (root) {
            buttonId = `${root} ${buttonId}`;
        }
        if (value instanceof Array) {
            checked = -1 < value.indexOf(itemValue);
        } else {
            checked = value === itemValue;
        }
        const props = { checked, title };
        return (
            <Checkbox {...props} value={itemValue} disabled={disabled} num={index} id={buttonId} name={title}
                                 key={index} onChangeCallback={this.onChangeHandler}/>
        );
    }
    buildOptionsList() {
        const options = this.props.options;
        return options.map(this.buildOption);
    }
    onChangeHandler(eventOrValue) {
        let updatedField = [], index;
        const { name, root, value, multipleChoice } = this.props;
        const newValue = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
        if (multipleChoice) {
            index = value ? value.indexOf(newValue) : null;
            updatedField = value && UNKNOWN !== value ? value.concat() : [];
        }
        if (!multipleChoice) {
            if (newValue === value) {
                this._resetFieldValue(name, root);
            } else {
                this._setFieldValue(name, newValue, root);
            }
        } else if (value && -1 < index) {
            updatedField.splice(index, 1);
            this._setFieldValue(name, updatedField, root);
        } else if (UNKNOWN === newValue) {
            this._setFieldValue(name, UNKNOWN, root);
        } else {
            updatedField.push(newValue);
            this._setFieldValue(name, updatedField, root);
        }
    }
    render() {
        const { value, unknownAccepted, disabled } = this.props;
        const isVisible = this.isVisible();
        return isVisible ? (
            <div className={style.fieldWrapper}>
                <div className={style.buttonsWrapper}>
                    { this.buildOptionsList() }
                </div>
                {
                    unknownAccepted
                        ? <DontKnowBtn disabled={disabled} onChangeCallback={this.onChangeHandler} value={UNKNOWN} checked={ UNKNOWN === value }/>
                        : null
                    }
            </div>
        ) : null;
    }
}
CheckboxButtons.propTypes = {
    id: TYPES.string.isRequired,
    name: TYPES.string.isRequired,
    unknownAccepted: TYPES.bool,
    multipleChoice: TYPES.bool,
    options: TYPES.array
};
CheckboxButtons.defaultProps = { unknownAccepted: false, multipleChoice: false };
